import classNames from "classnames";
import PropTypes from "prop-types";
import { Component } from "react";
import CloseButton from "./CloseButton";
import {
  bsClass, bsStyles, getClassSet, prefix, splitBsProps,
} from "./utils/bootstrapUtils";
import { State } from "./utils/StyleConfig";

const propTypes = {
  onDismiss: PropTypes.func,
  closeLabel: PropTypes.string,
};

const defaultProps = {
  closeLabel: "Close alert",
};

class Alert extends Component {
  render() {
    const {
      onDismiss, closeLabel, className, children, ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);

    const dismissable = !!onDismiss;
    const classes = {
      ...getClassSet(bsProps),
      [prefix(bsProps, "dismissable")]: dismissable,
    };

    return (
      <div
        {...elementProps}
        role="alert"
        className={classNames(className, classes)}
      >
        {dismissable && (

          <CloseButton
            onClick={onDismiss}
            label={closeLabel}
          />
        )}
        {children}
      </div>
    );
  }
}

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

export default bsStyles(Object.values(State), State.INFO,
  bsClass("alert", Alert));
